module.exports = __webpack_public_path__ + "img/logos.1fdcfa30.png";